import React, { Component, Fragment } from 'react';
import classnames from 'classnames';
import { Link } from 'utils/AppLink';
import Utils from './Utils';
import { getInternalWebsiteBaseUrl } from 'web-common/scripts/utils/whitelabelUtils';


class CommunityListView extends Component {

    toggleLead(personId, fullName, myLead) {
        this.props.toggleLead({
            personId: personId,
            fullName: fullName,
            eventId: this.props.event && this.props.event.id,
            myLead: myLead
        });
    }

    getImageOrLetters(item) {
        const letters = Utils.firstLetter(item.firstName) + Utils.firstLetter(item.lastName);
        const imgItem = (
            <Fragment>
                <div className={`${Utils.getImageShapeClassName(null, this.props.siteConf.template)} letters community-profile-img`}>{letters}</div>
                {
                    item.photoUrl &&
                    <img src={item.photoUrl}
                        className={`${Utils.getImageShapeClassName(null, this.props.siteConf.template)} community-profile-img`}
                        width="100%"
                        height="100%"
                        onError={event => event.target.style.display = 'none'}
                    />
                }
            </Fragment>
        );
        const imageShapeClassName = Utils.getImageShapeClassName('image-holder border-none', this.props.siteConf.template);
        return <div className={Utils.getImageShapeClassName('image-wrapper color-1', this.props.siteConf.template)}>
            <div className={`${imageShapeClassName} make-relative`}>
                {imgItem}
            </div>
        </div>;
    }

    downloadTheApp(insertDownloadTheAppIndex) {
        const eventName = this.props.event.name;
        const path = `${this.props.baseUrl}/deeplink`;
        const androidPath = `${path}/android`;
        const iosPath = `${path}/ios`;
        return <div className="community-list-item download-app-holder" key={insertDownloadTheAppIndex}>
            <div className="community-box margin-bottom-small color-1-background">
                <div className="community-list-item-image hidden-xs">
                    <div
                        className={Utils.getImageShapeClassName('image-wrapper color-1', this.props.siteConf.template)}>
                        <div
                            className={Utils.getImageShapeClassName('image-holder border-none', this.props.siteConf.template)}>
                            <div className="letters">
                                <i className="fa icon-mobile download-the-app-main-icon color-1"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="community-list-item-content download-the-app">
                    <div
                        className="header text-color-white">Download the Event App
                    </div>
                    <div
                        className="sub-header one-liner padding-horizontal-small text-color-white">Download '{eventName}' and enter
                    </div>
                    <div
                        className="sub-header one-liner padding-horizontal-small text-color-white">your email used for registration
                    </div>
                </div>
                <div className="community-list-item-buttons background-color-white download-the-app">
                    <Link to={iosPath} className="no-color" target="_blank">
                        <span className="send-message-button download-app">
                            <div className="text-wrapper">
                                <img src="/images/community/appStore.png" width="75%" height="75%"/>
                            </div>
                        </span>
                    </Link>
                    <Link to={androidPath} className="no-color" target="_blank">
                        <span className="mark-as-lead-button download-app">
                            <div className="text-wrapper">
                                <img src="/images/community/googlePlay.png" width="75%" height="75%"/>
                            </div>
                        </span>
                    </Link>
                </div>
            </div>
        </div>;
    }

    createLoadMoreItem(key) {
        return <div key={key}>
            <button className="load-more-button button-user-profile color-1 no-style-link-button"
                onClick={this.props.fetchMorePersons}>Load More
            </button>
        </div>;
    }

    createProfiles(items) {
        items = items || [];
        let cx = classnames;
        const {event} = this.props;
        let output = items.map((item, index) => {
            let isMe = this.props.me.id === item.id;

            let markedAsLead = cx('mark-as-lead-button', {
                'mark-as-lead-enabled color-1-background': item.myLead,
                'hide': isMe
            });
            let markedAsLeadText = cx('text-color-default font-normal no-style-link-button margin-right-small', {'color-1': item.myLead});
            let sendMessage = cx('send-message-button', {
                'hide': isMe
            });
            let isMeText = cx('is-me-text color-1', {'hide': !isMe});
            let sendMessageURL = getInternalWebsiteBaseUrl(this.props.event, 'inbox/' + item.id);

            return <div className="community-list-item" key={index}>
                <div className="community-box margin-bottom-small">
                    <Link to={getInternalWebsiteBaseUrl(this.props.event, 'person/' + item.id)}
                        className="no-color">
                        <div className="community-list-item-image">
                            {this.getImageOrLetters(item)}
                        </div>
                        <div className="community-list-item-content">
                            <div
                                className="header">{item.firstName} {item.lastName}</div>
                            <div
                                className="sub-header one-liner padding-horizontal-small">{item.title}</div>
                            <div
                                className="sub-header one-liner padding-horizontal-small">{item.company}</div>
                        </div>
                    </Link>
                    <div className="community-list-item-buttons">
                        <span className={sendMessage}>
                            <div className="text-wrapper">
                                <i className="fa icon-community_mail community-list-item-buttons-icon color-1"/>
                                <div className="margin-left-small">
                                    <Link to={sendMessageURL}><span
                                        className="text-color-default">SEND MESSAGE</span></Link>
                                </div>
                            </div>
                        </span>
                        <span className={markedAsLead}
                            onClick={() => this.toggleLead(item.id, Utils.getFullName(item.firstName, item.lastName), item.myLead)}>
                            <div className="text-wrapper">
                                <i className="fa icon-community_star community-list-item-buttons-icon color-1"/>
                                <button className={markedAsLeadText}>STAR</button>

                            </div>
                        </span>
                        <div className={isMeText}>
                            Hey! It's You!
                        </div>
                    </div>
                </div>
            </div>;
        });
        if (event['download-app-links']) {
            let insertDownloadTheAppIndex = items.length >= 3 ? 2 : (items.length - 1);
            output.splice(insertDownloadTheAppIndex, 0, this.downloadTheApp(output.length));
        }

        if (this.props.hasNextPage() && !this.props.isLoading) {
            const loadMoreItem = this.createLoadMoreItem(output.length);
            output.push(loadMoreItem);
        }
        return output;
    }

    createFaces() {
        return <div className="faces">
            <div className="image-linkdin-common" />
            <div className="separator margin-top-medium" />
        </div>;
    }

    render() {
        let cx = classnames;
        let isEmptyCommunity = cx({'hide': !this.props.persons});
        let isNotEmptyCommunity = cx('col-xs-12 text-center', {'hide': this.props.persons});

        return <div className="padding-bottom-huge">
            <div className={isEmptyCommunity}>{this.createProfiles(this.props.persons)}</div>
            <div className="col-xs-12 text-center">{this.props.isLoading && <i className="fa fa-spinner fa-spin"/>}</div>
            <div className={isNotEmptyCommunity}><strong>Sorry, no results were found...</strong></div>
        </div>;
    }
}

export default CommunityListView;
